import moreCollapsedImgNew from "@assets/header/newIcons/more-collapsed.svg";
import moreExpandedImgNew from "@assets/header/newIcons/more-expanded.svg";
import { SECTION_LIST_NEW } from "@components/Modules/HeaderNew/headerMenuConstants";
import { type ReactElement, useState } from "react";

import { HeaderMenuList } from "./HeaderMenuList";
import { SearchButton } from "./Search/SearchButton";
import { SearchInput } from "./Search/SearchInput";
import { SecondaryLinks } from "./SecondaryLinks";

export type SectionQuickLinksProps = Readonly<{
  testId?: string;
  hideScrollableSectionMenu?: boolean;
}>;

enum Buttons {
  MORE_BUTTON = "more",
  SEARCH_BUTTON = "search",
}

export function SectionQuickLinks({
  testId = "desktop-quick-links",
  hideScrollableSectionMenu = false,
}: SectionQuickLinksProps): ReactElement {
  const [searchExpanded, setSearchExpanded] = useState(false);
  const [moreMenuExpanded, setMoreMenuExpanded] = useState(false);
  const toggleExpanded = (type: Buttons) => {
    if (type === Buttons.MORE_BUTTON) {
      setMoreMenuExpanded((prev) => !prev);
      setSearchExpanded(false);
    } else {
      setMoreMenuExpanded(false);
      setSearchExpanded((prev) => !prev);
    }
  };

  const moreMenuExpandedClass = moreMenuExpanded ? "bg-neutral-200" : "";

  return (
    <>
      <div
        data-testid={`${testId}-quickLinks`}
        className={`flex justify-center text-sm font-medium lg:bg-bg-secondary`}
      >
        <div
          data-testid={`${testId}-quickLinksInner`}
          className="flex w-full lg:max-w-screen-lg xl:max-w-screen-bh-cxl"
        >
          <div
            data-testid={`${testId}-topicsListWrapper`}
            className="h-full flex w-full justify-between"
          >
            <div
              className={`h-[40px] lg:h-auto lg:gap-xs xl:gap-md px-xs xl:px-sm
               overflow-x-scroll lg:overflow-visible lg:flex-grow-no-shrink
               ${hideScrollableSectionMenu ? "hidden lg:flex" : "flex"}
               `}
            >
              <HeaderMenuList
                testId={testId}
                items={SECTION_LIST_NEW}
                type="topics"
              />
              <div
                className={`hidden lg:flex items-center lg:px-xs xl:px-sm ${moreMenuExpandedClass}`}
              >
                <button
                  className={`flex items-center gap-1 text-sm lg:text-brand-primary`}
                  onClick={() => {
                    toggleExpanded(Buttons.MORE_BUTTON);
                  }}
                >
                  More
                  <img
                    src={
                      moreMenuExpanded
                        ? moreExpandedImgNew
                        : moreCollapsedImgNew
                    }
                    alt="more-menu-icon"
                    width={12}
                    height={12}
                  />
                </button>
              </div>
            </div>
            <div
              data-testid={`${testId}-headerSearch`}
              className="hidden lg:block"
            >
              <SearchButton
                expanded={searchExpanded}
                onClick={() => {
                  toggleExpanded(Buttons.SEARCH_BUTTON);
                }}
                variant={"blue"}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        data-testid={`${testId}-secondaryNav`}
        className={`hidden lg:flex justify-center bg-neutral-200 transition-all duration-500 ease-in-out
            ${moreMenuExpanded ? "opacity-100 h-[35px] visible" : "opacity-0 h-0 invisible"}
          `}
      >
        <SecondaryLinks testId={testId} />
      </div>
      <div
        data-testid={`${testId}-searchInputDesktop`}
        className={`hidden lg:flex justify-center bg-neutral-200 transition-all duration-500 ease-in-out
            ${searchExpanded ? "opacity-100 h-[35px] visible" : "opacity-0 h-0 invisible"}
          `}
      >
        <SearchInput expanded={searchExpanded} />
      </div>
    </>
  );
}
